module.exports = __webpack_public_path__ + "img/pedro-pablo-kucynski.edb48e79.png";